var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{staticClass:"my-3",attrs:{"src":require('../assets/logo.png'),"contain":"","height":"350"}})],1),_c('v-col',{staticClass:"mb-4"},[_c('h2',{staticClass:"font-weight-bold mb-3"},[_vm._v("ОТКАЗАНО В ДОСТУПЕ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }